/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetUserIdQueryResponse,
  GetUserIdPathParams,
  GetUserId404,
} from "../types/GetUserId.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getUserIdQueryKey = (id: GetUserIdPathParams["id"] | undefined) =>
  [{ url: "/user/:id", params: { id: id } }] as const;

export type GetUserIdQueryKey = ReturnType<typeof getUserIdQueryKey>;

/**
 * @summary Получение профиля пользователя по ID
 * {@link /user/:id}
 */
export async function getUserId(
  id: GetUserIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetUserIdQueryResponse,
    ResponseErrorConfig<GetUserId404>,
    unknown
  >({ method: "GET", url: `/user/${id}`, ...requestConfig });
  return res;
}

export function getUserIdQueryOptions(
  id: GetUserIdPathParams["id"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getUserIdQueryKey(id);
  return queryOptions<
    ResponseConfig<GetUserIdQueryResponse>,
    ResponseErrorConfig<GetUserId404>,
    ResponseConfig<GetUserIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getUserId(id!, { ...config, signal: config.signal ?? signal });
    },
  });
}

/**
 * @summary Получение профиля пользователя по ID
 * {@link /user/:id}
 */
export function useGetUserId<
  TData = ResponseConfig<GetUserIdQueryResponse>,
  TQueryData = ResponseConfig<GetUserIdQueryResponse>,
  TQueryKey extends QueryKey = GetUserIdQueryKey,
>(
  id: GetUserIdPathParams["id"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetUserIdQueryResponse>,
        ResponseErrorConfig<GetUserId404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getUserIdQueryKey(id);

  const query = useQuery(
    {
      ...getUserIdQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetUserId404>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
